import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-support-tickets',
  templateUrl: './support-tickets.component.html',
  styleUrls: ['./support-tickets.component.css']
})
export class SupportTicketsComponent implements OnInit {
  @Input() sidebarMode: boolean = false;

  tickets: any[] = [];
  filteredTickets: any[] = [];
  selectedTicket: any = null;
  roleId: number = 3;
  userId: string = '0';
  replyForm: FormGroup;
  newTicketForm: FormGroup;
  showCreateForm: boolean = false;
  statusFilter: string = 'All';
  searchQuery: string = '';

  constructor(private globalService: GlobalService, private fb: FormBuilder) {
    this.replyForm = this.fb.group({
      message: ['', Validators.required]
    });
    this.newTicketForm = this.fb.group({
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.roleId = Number(localStorage.getItem('roleId')) || 3;
    this.userId = localStorage.getItem('userId') || '0';
    this.loadTickets();
  }

  loadTickets() {
    const allTickets = this.globalService.getSupportTickets();
    if (this.roleId === 1) {
      // Super Admin sees all tickets
      this.tickets = allTickets;
    } else {
      // Users see only their own tickets
      this.tickets = allTickets.filter(t => t.userId === this.userId);
    }
    this.applyFilters();
    if (this.selectedTicket) {
      const updated = this.tickets.find(t => t.id === this.selectedTicket.id);
      this.selectedTicket = updated ? updated : null;
    }
  }

  applyFilters() {
    let result = this.tickets;

    if (this.statusFilter !== 'All') {
      result = result.filter(t => t.status === this.statusFilter);
    }

    if (this.searchQuery.trim() !== '') {
      const q = this.searchQuery.toLowerCase();
      result = result.filter(t =>
        t.subject.toLowerCase().includes(q) ||
        t.userName.toLowerCase().includes(q) ||
        (t.message && t.message.toLowerCase().includes(q))
      );
    }

    this.filteredTickets = result;
  }

  selectTicket(ticket: any) {
    this.selectedTicket = ticket;
    this.showCreateForm = false;
    this.replyForm.reset();
  }

  deselectTicket() {
    this.selectedTicket = null;
  }

  toggleCreateForm() {
    this.showCreateForm = !this.showCreateForm;
    if (this.showCreateForm) {
      this.selectedTicket = null;
      this.newTicketForm.reset();
    }
  }

  submitTicket() {
    if (this.newTicketForm.valid) {
      const subject = this.newTicketForm.value.subject;
      const message = this.newTicketForm.value.message;
      const newTicket = this.globalService.addSupportTicketLocal(subject, message);
      this.loadTickets();
      this.selectTicket(newTicket);
      this.showCreateForm = false;
    }
  }

  submitReply() {
    if (this.replyForm.valid && this.selectedTicket) {
      const msg = this.replyForm.value.message;
      this.globalService.addCommentLocal(this.selectedTicket.id, msg);
      this.replyForm.reset();
      this.loadTickets();
    }
  }

  toggleTicketStatus() {
    if (this.selectedTicket) {
      const nextStatus = this.selectedTicket.status === 'Open' ? 'Closed' : 'Open';
      this.globalService.updateTicketStatusLocal(this.selectedTicket.id, nextStatus);
      this.loadTickets();
    }
  }

  filterByStatus(status: string) {
    this.statusFilter = status;
    this.applyFilters();
  }

  onSearch() {
    this.applyFilters();
  }
}
